<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chicurren0008#pref_acknow">Preface and Acknowledgments</a></p>
<p class="toc"><a class="xref" href="#/chicurren0009#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chicurren0010#ch01"><span class="ac">one</span> / Americanizing Curricula</a></p>
<p class="toc"><a class="xref" href="#/chicurren0011#ch02"><span class="ac">two</span> / Heroes and Rituals</a></p>
<p class="toc"><a class="xref" href="#/chicurren0012#ch03"><span class="ac">three</span> / Militarizing Schools, Mobilizing Students</a></p>
<p class="toc"><a class="xref" href="#/chicurren0013#ch04"><span class="ac">four</span> / The Education We Need</a></p>
<p class="toc"><a class="xref" href="#/chicurren0014#ch05"><span class="ac">five</span> / Cultivating Civic Virtue</a></p>
<p class="toc"><a class="xref" href="#/chicurren0015#ch06"><span class="ac">six</span> / Global Civic Education</a></p>
<p class="toc"><a class="xref" href="#/chicurren0016#conc"><span class="ac">Conclusion</span> / Realizing America in a Global Age</a></p>
<p class="tocbmf"><a class="xref" href="#/chicurren0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chicurren0018#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-curren-0007.vue?164afaa2